import config from "../../chatbot/config.js";
import ActionProvider from "../../chatbot/ActionProvider.jsx";
import MessageParser from "../../chatbot/MessageParser.jsx";
import Chatbot from "react-chatbot-kit";
import "../../chatbot/chatbot.css";
import styled from "styled-components";


export const MyChatbot = () => {

    const saveMessages = (messages, HTMLString) => {
      localStorage.setItem("chat_messages", JSON.stringify(messages));
    };

    const loadMessages = () => {
      const messages = JSON.parse(localStorage.getItem("chat_messages"));
      return messages;
    };
  return (
    <BotContainer className="botContainer">
        <Header className="header">
            Feel free to use the chatbot to know more about the projects !
        </Header>
        <hr />
        <Chatbot
          config={config}
          actionProvider={ActionProvider}
          messageHistory={loadMessages()}
          messageParser={MessageParser}
          saveMessages={saveMessages}
          runInitialMessagesWithHistory
        />
    </BotContainer>
  );
};

const BotContainer = styled.div`
    // border: solid white 13px;
    margin: 0 auto;
    width: 40vw;
    padding: 2vw;
    padding-top: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
`

const Header = styled.h4`
    color: white;
    text-align: center;
`